/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Insights_Point_RecallInputs */

const en_why_listening_insights_point_recall = /** @type {(inputs: Why_Listening_Insights_Point_RecallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Higher density predicts better recall`)
};

const es_why_listening_insights_point_recall = /** @type {(inputs: Why_Listening_Insights_Point_RecallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una mayor densidad predice un mejor recuerdo`)
};

/**
* | output |
* | --- |
* | "Higher density predicts better recall" |
*
* @param {Why_Listening_Insights_Point_RecallInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_insights_point_recall = /** @type {((inputs?: Why_Listening_Insights_Point_RecallInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Insights_Point_RecallInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_insights_point_recall(inputs)
	return en_why_listening_insights_point_recall(inputs)
});